import { ReactComponent as HtmlIconSvg } from 'new/components/icons/fileTypes/html.svg';
import { ReactComponent as CssIconSvg } from 'new/components/icons/fileTypes/css.svg';
import { ReactComponent as JsIconSvg } from 'new/components/icons/fileTypes/javascript.svg';
import { ReactComponent as TsIconSvg } from 'new/components/icons/fileTypes/typescript.svg';
import { ReactComponent as ReactIconSvg } from 'new/components/icons/fileTypes/react.svg';
import { ReactComponent as JsonIconSvg } from 'new/components/icons/fileTypes/json.svg';
import { ReactComponent as CsvIconSvg } from 'new/components/icons/fileTypes/csv.svg';
import { ReactComponent as XmlIconSvg } from 'new/components/icons/fileTypes/xml.svg';
import { ReactComponent as YamlIconSvg } from 'new/components/icons/fileTypes/yaml.svg';
import { ReactComponent as TomlIconSvg } from 'new/components/icons/fileTypes/toml.svg';
import { ReactComponent as PdfIconSvg } from 'new/components/icons/fileTypes/pdf.svg';
import { ReactComponent as ExcelIconSvg } from 'new/components/icons/fileTypes/excel.svg';
import { ReactComponent as WordIconSvg } from 'new/components/icons/fileTypes/word.svg';
import { ReactComponent as ImageIconSvg } from 'new/components/icons/fileTypes/image.svg';
import { ReactComponent as SvgIconSvg } from 'new/components/icons/fileTypes/svg.svg';
import { ReactComponent as ConfigIconSvg } from 'new/components/icons/fileTypes/config.svg';
import { ReactComponent as PythonIconSvg } from 'new/components/icons/fileTypes/python.svg';
import { ReactComponent as ShellIconSvg } from 'new/components/icons/fileTypes/shell.svg';
import { ReactComponent as PowerShellIconSvg } from 'new/components/icons/fileTypes/powershell.svg';
import { ReactComponent as ArchiveIconSvg } from 'new/components/icons/fileTypes/archive.svg';
import { ReactComponent as TextIconSvg } from 'new/components/icons/fileTypes/text.svg';
import { ReactComponent as AvroIconSvg } from 'new/components/icons/fileTypes/avro.svg';
import { ReactComponent as ParquetIconSvg } from 'new/components/icons/fileTypes/parquet.svg';
import { ReactComponent as MarkdownIconSvg } from 'new/components/icons/fileTypes/markdown.svg';
import { ReactComponent as VideoIconSvg } from 'new/components/icons/fileTypes/video.svg';
import { ReactComponent as GoogleDocsIconSvg } from 'new/components/icons/fileTypes/google-docs.svg';
import { ReactComponent as BatIconSvg } from 'new/components/icons/fileTypes/bat.svg';
import { ReactComponent as AiIconSvg } from 'new/components/icons/fileTypes/ai.svg';
import { ReactComponent as AndroidIconSvg } from 'new/components/icons/fileTypes/android.svg';
import { ReactComponent as BinaryIconSvg } from 'new/components/icons/fileTypes/binary.svg';
import { ReactComponent as DebianIconSvg } from 'new/components/icons/fileTypes/debian.svg';
import { ReactComponent as JavaIconSvg } from 'new/components/icons/fileTypes/java.svg';
import { ReactComponent as AudioIconSvg } from 'new/components/icons/fileTypes/audio.svg';
import { ReactComponent as LibreOfficeWriterIconSvg } from 'new/components/icons/fileTypes/odt.svg';
import { ReactComponent as FontIconSvg } from 'new/components/icons/fileTypes/font.svg';
import { ReactComponent as PhpIconSvg } from 'new/components/icons/fileTypes/php.svg';
import { ReactComponent as RubyIconSvg } from 'new/components/icons/fileTypes/ruby.svg';
import { ReactComponent as SqlIconSvg } from 'new/components/icons/fileTypes/sql.svg';
import { ReactComponent as SqliteIconSvg } from 'new/components/icons/fileTypes/sqlite.svg';
import { ReactComponent as ScssIconSvg } from 'new/components/icons/fileTypes/scss.svg';
import { ReactComponent as SwiftIconSvg } from 'new/components/icons/fileTypes/swift.svg';
import { ReactComponent as DockerIconSvg } from 'new/components/icons/fileTypes/docker.svg';
import { ReactComponent as CppIconSvg } from 'new/components/icons/fileTypes/cpp.svg';
import { ReactComponent as GoIconSvg } from 'new/components/icons/fileTypes/go.svg';
import { ReactComponent as KotlinIconSvg } from 'new/components/icons/fileTypes/kotlin.svg';
import { ReactComponent as PowerPointIconSvg } from 'new/components/icons/fileTypes/powerpoint.svg';
import { ReactComponent as GoogleSlidesIconSvg } from 'new/components/icons/fileTypes/google-slides.svg';
import { ReactComponent as GoogleFormsIconSvg } from 'new/components/icons/fileTypes/google-forms.svg';
import { ReactComponent as GoogleSheetsIconSvg } from 'new/components/icons/fileTypes/google-sheets.svg';
import { ReactComponent as CIconSvg } from 'new/components/icons/fileTypes/c.svg';
import { ReactComponent as CHeaderIconSvg } from 'new/components/icons/fileTypes/c-header.svg';
import { ReactComponent as CppHeaderIconSvg } from 'new/components/icons/fileTypes/cpp-header.svg';
import { ReactComponent as CSharpIconSvg } from 'new/components/icons/fileTypes/csharp.svg';
import { ReactComponent as RustIconSvg } from 'new/components/icons/fileTypes/rust.svg';
import { ReactComponent as ScalaIconSvg } from 'new/components/icons/fileTypes/scala.svg';
import { ReactComponent as LuaIconSvg } from 'new/components/icons/fileTypes/lua.svg';
import { ReactComponent as PerlIconSvg } from 'new/components/icons/fileTypes/perl.svg';
import { ReactComponent as SassIconSvg } from 'new/components/icons/fileTypes/sass.svg';
import { ReactComponent as LessIconSvg } from 'new/components/icons/fileTypes/less.svg';
import { ReactComponent as TexIconSvg } from 'new/components/icons/fileTypes/tex.svg';
import { ReactComponent as PhotoshopIconSvg } from 'new/components/icons/fileTypes/photoshop.svg';
import { ReactComponent as EpsIconSvg } from 'new/components/icons/fileTypes/eps.svg';
import { ReactComponent as LibreOfficeImpressIconSvg } from 'new/components/icons/fileTypes/odp.svg';
import { ReactComponent as LibreOfficeCalcIconSvg } from 'new/components/icons/fileTypes/ods.svg';
import { ReactComponent as EpubIconSvg } from 'new/components/icons/fileTypes/epub.svg';
import { ReactComponent as BakIconSvg } from 'new/components/icons/fileTypes/bak.svg';
import { ReactComponent as LogIconSvg } from 'new/components/icons/fileTypes/log.svg';
import { ReactComponent as BittorrentIconSvg } from 'new/components/icons/fileTypes/bittorrent.svg';
import { ReactComponent as RedHatIconSvg } from 'new/components/icons/fileTypes/redhat.svg';
import { asIconComponent as asIcon } from '../FileIconResolver';
import type { IconMapping } from '../FileIconResolver';

const HtmlIcon = asIcon(HtmlIconSvg);
const CssIcon = asIcon(CssIconSvg);
const JsIcon = asIcon(JsIconSvg);
const TsIcon = asIcon(TsIconSvg);
const ReactIcon = asIcon(ReactIconSvg);
const JsonIcon = asIcon(JsonIconSvg);
const CsvIcon = asIcon(CsvIconSvg);
const XmlIcon = asIcon(XmlIconSvg);
const YamlIcon = asIcon(YamlIconSvg);
const TomlIcon = asIcon(TomlIconSvg);
const PdfIcon = asIcon(PdfIconSvg);
const ExcelIcon = asIcon(ExcelIconSvg);
const WordIcon = asIcon(WordIconSvg);
const ImageIcon = asIcon(ImageIconSvg);
const SvgIcon = asIcon(SvgIconSvg);
const ConfigIcon = asIcon(ConfigIconSvg);
const PythonIcon = asIcon(PythonIconSvg);
const ShellIcon = asIcon(ShellIconSvg);
const PowerShellIcon = asIcon(PowerShellIconSvg);
const ArchiveIcon = asIcon(ArchiveIconSvg);
const TextIcon = asIcon(TextIconSvg);
const AvroIcon = asIcon(AvroIconSvg);
const ParquetIcon = asIcon(ParquetIconSvg);
const MarkdownIcon = asIcon(MarkdownIconSvg);
const VideoIcon = asIcon(VideoIconSvg);
const GoogleDocsIcon = asIcon(GoogleDocsIconSvg);
const BatIcon = asIcon(BatIconSvg);
const AiIcon = asIcon(AiIconSvg);
const AndroidIcon = asIcon(AndroidIconSvg);
const BinaryIcon = asIcon(BinaryIconSvg);
const DebianIcon = asIcon(DebianIconSvg);
const JavaIcon = asIcon(JavaIconSvg);
const AudioIcon = asIcon(AudioIconSvg);
const LibreOfficeWriterIcon = asIcon(LibreOfficeWriterIconSvg);
const FontIcon = asIcon(FontIconSvg);
const PhpIcon = asIcon(PhpIconSvg);
const RubyIcon = asIcon(RubyIconSvg);
const SqlIcon = asIcon(SqlIconSvg);
const SqliteIcon = asIcon(SqliteIconSvg);
const ScssIcon = asIcon(ScssIconSvg);
const SwiftIcon = asIcon(SwiftIconSvg);
const DockerIcon = asIcon(DockerIconSvg);
const CppIcon = asIcon(CppIconSvg);
const GoIcon = asIcon(GoIconSvg);
const KotlinIcon = asIcon(KotlinIconSvg);
const PowerPointIcon = asIcon(PowerPointIconSvg);
const GoogleSlidesIcon = asIcon(GoogleSlidesIconSvg);
const GoogleFormsIcon = asIcon(GoogleFormsIconSvg);
const GoogleSheetsIcon = asIcon(GoogleSheetsIconSvg);
const CIcon = asIcon(CIconSvg);
const CHeaderIcon = asIcon(CHeaderIconSvg);
const CppHeaderIcon = asIcon(CppHeaderIconSvg);
const CSharpIcon = asIcon(CSharpIconSvg);
const RustIcon = asIcon(RustIconSvg);
const ScalaIcon = asIcon(ScalaIconSvg);
const LuaIcon = asIcon(LuaIconSvg);
const PerlIcon = asIcon(PerlIconSvg);
const SassIcon = asIcon(SassIconSvg);
const LessIcon = asIcon(LessIconSvg);
const TexIcon = asIcon(TexIconSvg);
const PhotoshopIcon = asIcon(PhotoshopIconSvg);
const EpsIcon = asIcon(EpsIconSvg);
const LibreOfficeImpressIcon = asIcon(LibreOfficeImpressIconSvg);
const LibreOfficeCalcIcon = asIcon(LibreOfficeCalcIconSvg);
const EpubIcon = asIcon(EpubIconSvg);
const BakIcon = asIcon(BakIconSvg);
const LogIcon = asIcon(LogIconSvg);
const BittorrentIcon = asIcon(BittorrentIconSvg);
const RedHatIcon = asIcon(RedHatIconSvg);

/** Provides the built-in VS Code-style file-type mappings. */
export const defaultMappingsAdapter = (): IconMapping[] => [
  { extensions: ['html', 'htm'], mimeTypes: ['text/html'], icon: HtmlIcon },
  { extensions: ['css'], mimeTypes: ['text/css'], icon: CssIcon },
  {
    extensions: ['js', 'mjs', 'cjs'],
    mimeTypes: ['application/javascript', 'text/javascript'],
    icon: JsIcon,
  },
  { extensions: ['ts', 'tsx', 'mts', 'cts'], mimeTypes: ['application/typescript'], icon: TsIcon },
  { extensions: ['jsx'], mimeTypes: ['text/jsx'], icon: ReactIcon },
  { extensions: ['json'], mimeTypes: ['application/json'], icon: JsonIcon },
  { extensions: ['csv'], mimeTypes: ['text/csv'], icon: CsvIcon },
  { extensions: ['xml'], mimeTypes: ['application/xml', 'text/xml'], icon: XmlIcon },
  { extensions: ['yaml', 'yml'], mimeTypes: ['application/yaml', 'text/yaml'], icon: YamlIcon },
  { extensions: ['toml'], mimeTypes: ['application/toml'], icon: TomlIcon },
  { extensions: ['pdf'], mimeTypes: ['application/pdf'], icon: PdfIcon },
  { extensions: ['xlsx', 'xls'], mimeTypes: ['application/vnd.ms-excel'], icon: ExcelIcon },
  {
    extensions: ['doc', 'docx', 'rtf'],
    mimeTypes: ['application/msword', 'application/rtf'],
    icon: WordIcon,
  },
  {
    // 'raw' (camera RAW) is grouped with images on purpose — vscode-icons itself files it under
    // its audio icon (presumably for raw PCM), which wouldn't fit this product's file browsers.
    extensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tif', 'tiff', 'heic', 'ico', 'raw'],
    mimeTypes: [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/bmp',
      'image/tiff',
      'image/heic',
      'image/x-icon',
      'image/x-raw',
    ],
    icon: ImageIcon,
    category: 'image',
  },
  { extensions: ['svg'], mimeTypes: ['image/svg+xml'], icon: SvgIcon },
  { extensions: ['env', 'ini', 'conf', 'cfg', 'properties'], icon: ConfigIcon },
  { extensions: ['py'], mimeTypes: ['text/x-python'], icon: PythonIcon },
  { extensions: ['sh'], mimeTypes: ['application/x-sh'], icon: ShellIcon },
  { extensions: ['ps1'], icon: PowerShellIcon },
  {
    extensions: ['zip', 'tar', 'gz', 'rar', 'xz', '7z', 'bz2'],
    mimeTypes: [
      'application/zip',
      'application/gzip',
      'application/vnd.rar',
      'application/x-xz',
      'application/x-7z-compressed',
      'application/x-bzip2',
    ],
    icon: ArchiveIcon,
  },
  { extensions: ['txt'], mimeTypes: ['text/plain'], icon: TextIcon },
  { extensions: ['avro'], mimeTypes: ['avro/binary', 'application/avro'], icon: AvroIcon },
  {
    extensions: ['parquet'],
    mimeTypes: ['application/vnd.apache.parquet', 'application/x-parquet'],
    icon: ParquetIcon,
  },
  { extensions: ['md', 'markdown'], mimeTypes: ['text/markdown'], icon: MarkdownIcon },
  {
    extensions: ['mov', 'mp4', 'avi', 'mkv', 'webm', 'wmv', 'flv', 'm4v'],
    mimeTypes: [
      'video/quicktime',
      'video/mp4',
      'video/x-msvideo',
      'video/x-matroska',
      'video/webm',
      'video/x-ms-wmv',
      'video/flv',
    ],
    icon: VideoIcon,
    category: 'video',
  },
  {
    extensions: [],
    mimeTypes: ['application/vnd.google-apps.document'],
    icon: GoogleDocsIcon,
  },
  { extensions: ['bat'], icon: BatIcon },
  { extensions: ['ai'], mimeTypes: ['application/illustrator'], icon: AiIcon },
  {
    extensions: ['apk'],
    mimeTypes: ['application/vnd.android.package-archive'],
    icon: AndroidIcon,
  },
  {
    extensions: ['app', 'exe', 'dmg', 'iso', 'msi'],
    mimeTypes: [
      'application/x-msdownload',
      'application/x-apple-diskimage',
      'application/x-iso9660-image',
      'application/x-msi',
    ],
    icon: BinaryIcon,
  },
  { extensions: ['deb'], mimeTypes: ['application/x-debian-package'], icon: DebianIcon },
  { extensions: ['java'], mimeTypes: ['text/x-java-source'], icon: JavaIcon },
  {
    extensions: ['mp3', 'aac', 'wav', 'wma', 'm4a', 'flac', 'ogg'],
    mimeTypes: [
      'audio/mpeg',
      'audio/aac',
      'audio/wav',
      'audio/x-ms-wma',
      'audio/x-m4a',
      'audio/flac',
      'audio/ogg',
    ],
    icon: AudioIcon,
    category: 'audio',
  },
  {
    extensions: ['odt'],
    mimeTypes: ['application/vnd.oasis.opendocument.text'],
    icon: LibreOfficeWriterIcon,
  },
  {
    extensions: ['otf', 'woff', 'woff2', 'ttf'],
    mimeTypes: ['font/otf', 'font/woff', 'font/woff2', 'font/ttf'],
    icon: FontIcon,
    category: 'font',
  },
  { extensions: ['php'], mimeTypes: ['application/x-httpd-php'], icon: PhpIcon },
  { extensions: ['rb'], mimeTypes: ['text/x-ruby'], icon: RubyIcon },
  { extensions: ['sql', 'db'], mimeTypes: ['application/sql'], icon: SqlIcon },
  {
    extensions: ['sqlite', 'sqlite3'],
    mimeTypes: ['application/vnd.sqlite3'],
    icon: SqliteIcon,
  },
  { extensions: ['scss'], mimeTypes: ['text/x-scss'], icon: ScssIcon },
  { extensions: ['swift'], mimeTypes: ['text/x-swift'], icon: SwiftIcon },
  { extensions: ['dockerfile'], filenames: ['dockerfile'], icon: DockerIcon },
  { extensions: ['cpp'], mimeTypes: ['text/x-c++src'], icon: CppIcon },
  { extensions: ['go'], mimeTypes: ['text/x-go'], icon: GoIcon },
  { extensions: ['kt'], mimeTypes: ['text/x-kotlin'], icon: KotlinIcon },
  {
    extensions: ['pptx', 'ppt'],
    mimeTypes: [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-powerpoint',
    ],
    icon: PowerPointIcon,
  },
  {
    extensions: [],
    mimeTypes: ['application/vnd.google-apps.presentation'],
    icon: GoogleSlidesIcon,
  },
  {
    extensions: [],
    mimeTypes: ['application/vnd.google-apps.form'],
    icon: GoogleFormsIcon,
  },
  {
    extensions: [],
    mimeTypes: ['application/vnd.google-apps.spreadsheet'],
    icon: GoogleSheetsIcon,
  },
  { extensions: ['c'], mimeTypes: ['text/x-csrc'], icon: CIcon },
  { extensions: ['h'], mimeTypes: ['text/x-chdr'], icon: CHeaderIcon },
  { extensions: ['hpp'], icon: CppHeaderIcon },
  { extensions: ['cs'], mimeTypes: ['text/x-csharp'], icon: CSharpIcon },
  { extensions: ['rs'], icon: RustIcon },
  { extensions: ['scala'], icon: ScalaIcon },
  { extensions: ['lua'], icon: LuaIcon },
  { extensions: ['pl'], mimeTypes: ['text/x-perl'], icon: PerlIcon },
  { extensions: ['sass'], icon: SassIcon },
  { extensions: ['less'], icon: LessIcon },
  { extensions: ['tex'], mimeTypes: ['text/x-tex'], icon: TexIcon },
  { extensions: ['psd'], mimeTypes: ['image/x-photoshop'], icon: PhotoshopIcon },
  { extensions: ['eps'], mimeTypes: ['application/postscript'], icon: EpsIcon },
  {
    extensions: ['odp'],
    mimeTypes: ['application/vnd.oasis.opendocument.presentation'],
    icon: LibreOfficeImpressIcon,
  },
  {
    extensions: ['ods'],
    mimeTypes: ['application/vnd.oasis.opendocument.spreadsheet'],
    icon: LibreOfficeCalcIcon,
  },
  {
    extensions: ['epub', 'mobi', 'azw3'],
    mimeTypes: ['application/epub+zip'],
    icon: EpubIcon,
  },
  { extensions: ['bak'], icon: BakIcon },
  { extensions: ['log'], icon: LogIcon },
  { extensions: ['torrent'], mimeTypes: ['application/x-bittorrent'], icon: BittorrentIcon },
  // RPM isn't Red-Hat-exclusive (Fedora, openSUSE, etc. use it too), but no distro-neutral
  // asset exists in either icon source — same tradeoff already accepted for .deb/Debian above.
  {
    extensions: ['rpm'],
    mimeTypes: ['application/x-redhat-package-manager'],
    icon: RedHatIcon,
  },
  // Apple iWork formats have no dedicated asset in vscode-icons or Simple Icons, so each reuses
  // the icon of the closest Office equivalent. Note vscode-icons' own file_type_key.svg is a
  // cryptographic/license key glyph, not Keynote — deliberately not used here.
  { extensions: ['key'], mimeTypes: ['application/x-iwork-keynote-sffkey'], icon: PowerPointIcon },
  {
    extensions: ['numbers'],
    mimeTypes: ['application/x-iwork-numbers-sffnumbers'],
    icon: ExcelIcon,
  },
  { extensions: ['pages'], mimeTypes: ['application/x-iwork-pages-sffpages'], icon: WordIcon },
];
